import l from "../../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
import s from "../../../../warning/warning.es.js";
const t = typeof window < "u", u = t && window.location.protocol === "file:";
function c(r) {
  return typeof r < "u";
}
function E(r) {
  return c(r) && r !== null;
}
function d(r) {
  return typeof r == "string";
}
function b(r) {
  return r instanceof ArrayBuffer;
}
function p(r) {
  return l(t, "isBlob can only be used in a browser environment"), r instanceof Blob;
}
function w(r) {
  return d(r) && /^data:/.test(r);
}
function y(r) {
  l(w(r), "Invalid data URI.");
  const [n = "", e = ""] = r.split(",");
  return n.split(";").indexOf("base64") !== -1 ? atob(e) : unescape(e);
}
function R() {
  return t && window.devicePixelRatio || 1;
}
const f = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function m() {
  s(!u, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${f}`);
}
function P() {
  s(!u, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${f}`);
}
function F(r) {
  r?.cancel && r.cancel();
}
function O(r, n) {
  return Object.defineProperty(r, "width", {
    get() {
      return this.view[2] * n;
    },
    configurable: !0
  }), Object.defineProperty(r, "height", {
    get() {
      return this.view[3] * n;
    },
    configurable: !0
  }), Object.defineProperty(r, "originalWidth", {
    get() {
      return this.view[2];
    },
    configurable: !0
  }), Object.defineProperty(r, "originalHeight", {
    get() {
      return this.view[3];
    },
    configurable: !0
  }), r;
}
function S(r) {
  return r.name === "RenderingCancelledException";
}
function T(r) {
  return new Promise((n, e) => {
    const i = new FileReader();
    i.onload = () => {
      if (!i.result)
        return e(new Error("Error while reading a file."));
      n(i.result);
    }, i.onerror = (a) => {
      if (!a.target)
        return e(new Error("Error while reading a file."));
      const { error: o } = a.target;
      if (!o)
        return e(new Error("Error while reading a file."));
      switch (o.code) {
        case o.NOT_FOUND_ERR:
          return e(new Error("Error while reading a file: File not found."));
        case o.SECURITY_ERR:
          return e(new Error("Error while reading a file: Security error."));
        case o.ABORT_ERR:
          return e(new Error("Error while reading a file: Aborted."));
        default:
          return e(new Error("Error while reading a file."));
      }
    }, i.readAsArrayBuffer(r);
  });
}
export {
  F as cancelRunningTask,
  y as dataURItoByteString,
  m as displayCORSWarning,
  P as displayWorkerWarning,
  R as getDevicePixelRatio,
  b as isArrayBuffer,
  p as isBlob,
  t as isBrowser,
  S as isCancelException,
  w as isDataURI,
  c as isDefined,
  u as isLocalFileSystem,
  E as isProvided,
  d as isString,
  T as loadFromFile,
  O as makePageCallback
};
//# sourceMappingURL=utils.es.js.map
